<template>
  <div id="pastPaper">
    <Preloader v-if="!loaded" />
    <div class="container-fluid">
      <div class="row pt-2">
        <div class="col-sm-12">
          <h4 class="bg-secondary text-white text-start rounded p-1 ps-2">
            Past Question Papers: {{eventName}}, {{categoryName}}
<!--            {{siteTitle}} Past Question Papers-->
          </h4>
          <div class="table-responsive">
            <table class="table caption-top table-striped text-start">
              <thead>
              <tr>
                <th class="text-center" style="width: 50px">Sl</th>
                <th>Round</th>
                <th>Title</th>
                <th class="text-center" style="width: 100px"> Link</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(paper,key) in papers" :key="key">
                <td class="text-center">{{key+1}}</td>
                <td>{{paper.round}}</td>
                <td>{{paper.title}}</td>
                <td class="text-center">
                  <a target="_blank" download :href="paper.url">Open</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Preloader from "@/components/Preloader.vue";

  export default {
    name: "PastPaper",
    components: {Preloader},
    data(){
      return{
        eventId: this.$route.params.eventId,
        categoryId: this.$route.params.categoryId,
        loaded:true,
        eventName:'',
        categoryName:'',
        papers:[],
      }
    },
    created() {
      this.$http.get("get-past-papers-list/"+this.eventId+"/"+this.categoryId).then(function (response) {
      // this.$http.get("get-past-papers-list", ).then(function (response) {
        console.log(response.body)
        this.papers = response.body.papers
        this.eventName = response.body.event;
        this.categoryName = response.body.category;
        this.loaded=true;
      })
    },
    computed:{
      siteTitle(){return this.$store.getters.getSiteTitle;},
      pastPapers(){return this.$store.getters.getPastPapers;},
    },
  }
</script>

<style scoped>

</style>
